import { render } from "./MultiStringControlRenderer.vue?vue&type=template&id=4c36cabd&ts=true"
import script from "./MultiStringControlRenderer.vue?vue&type=script&lang=ts"
export * from "./MultiStringControlRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__